var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionOfPricesDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.524,
    height: 166.9,
    viewBox: "0 0 300.524 166.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14352",
    "data-name": "Rectangle 14352",
    width: 300.524,
    height: 166.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14333",
    "data-name": "Rectangle 14333",
    width: 28.545,
    height: 52.715,
    fill: "#58dfc3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14331",
    "data-name": "Rectangle 14331",
    width: 11.453,
    height: 43.818,
    fill: "#58dfc3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14332",
    "data-name": "Rectangle 14332",
    width: 27.781,
    height: 52.715,
    fill: "#58dfc3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14336",
    "data-name": "Rectangle 14336",
    width: 102.191,
    height: 135.787,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14349",
    "data-name": "Rectangle 14349",
    width: 29.269,
    height: 8.117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14350",
    "data-name": "Rectangle 14350",
    width: 25.786,
    height: 33.603,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14351",
    "data-name": "Rectangle 14351",
    width: 36.106,
    height: 36.105,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8517",
    "data-name": "Group 8517",
    transform: "translate(-209 -184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8516",
    "data-name": "Group 8516",
    transform: "translate(209 184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8513",
    "data-name": "Group 8513",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13349",
    "data-name": "Path 13349",
    d: "M287.157,166.494c-16.259,0-260.348.058-260.485-.366l-.023-.054a.287.287,0,0,1-.023-.079c-.091-.212-47-19.108-16.079-61.375C26.753,82.47-2.179,48.556,32.268,18.631c53.979-46.893,105.491,10.866,127.326,0C177.947,9.5,207.441-3.59,237.379,8.146c8.226,3.225,26.039,19.4,11.247,46.6-7.391,13.592,25.408,15.17,37.405,29.612,26.128,31.45,10.849,82.132,1.126,82.132",
    transform: "translate(0 -0.004)",
    fill: "#efeffa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8500",
    "data-name": "Group 8500",
    transform: "translate(195.521 23.313)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8499",
    "data-name": "Group 8499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8498",
    "data-name": "Group 8498",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8494",
    "data-name": "Group 8494",
    transform: "translate(0 1.619)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8493",
    "data-name": "Group 8493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8492",
    "data-name": "Group 8492",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13350",
    "data-name": "Path 13350",
    d: "M1607.593,248.749s-3.135-24.829,5.632-42.3a2.779,2.779,0,0,1,5.187.645c.01.042.019.085.028.128.913,4.341-8.4,25.933-10.846,41.525",
    transform: "translate(-1607.048 -204.931)",
    fill: "#58dfc3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8497",
    "data-name": "Group 8497",
    transform: "translate(0.764)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8496",
    "data-name": "Group 8496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8495",
    "data-name": "Group 8495",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13351",
    "data-name": "Path 13351",
    d: "M1613.334,244.333s4.8-33.206,22.5-51.779a2.948,2.948,0,0,1,4.061-.234c.763.675,1.332,1.886,1.2,4.03-.354,5.718-19.356,29.409-27.761,47.983",
    transform: "translate(-1613.334 -191.618)",
    fill: "#58dfc3"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8503",
    "data-name": "Group 8503",
    transform: "translate(30.603 30.705)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8502",
    "data-name": "Group 8502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8501",
    "data-name": "Group 8501",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13352",
    "data-name": "Path 13352",
    d: "M297.351,354.071h10.5a1.674,1.674,0,0,0,1.674-1.674V308.19a1.674,1.674,0,0,0-1.674-1.674h-10.5a1.674,1.674,0,0,0-1.674,1.674V352.4a1.673,1.673,0,0,0,1.674,1.674",
    transform: "translate(-290.306 -299.93)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13353",
    "data-name": "Path 13353",
    d: "M332.409,589.646a3.246,3.246,0,1,0-3.246,3.246,3.246,3.246,0,0,0,3.246-3.246",
    transform: "translate(-316.866 -545.761)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13354",
    "data-name": "Path 13354",
    d: "M326.68,590.909a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-314.384 -543.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13355",
    "data-name": "Path 13355",
    d: "M319.867,351.134h6.875a.618.618,0,0,0,.618-.618V325.021a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-311.011 -315.64)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13356",
    "data-name": "Path 13356",
    d: "M327.553,333.426h5.061a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-317.872 -322.624)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13357",
    "data-name": "Path 13357",
    d: "M361.1,470.831v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-347.771 -444.018)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13358",
    "data-name": "Path 13358",
    d: "M361.1,408.527v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-347.771 -389.294)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13359",
    "data-name": "Path 13359",
    d: "M335.839,470.831v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-325.582 -444.018)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13360",
    "data-name": "Path 13360",
    d: "M335.839,408.527v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-325.582 -389.294)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13361",
    "data-name": "Path 13361",
    d: "M348.984,458.051v7.065a.268.268,0,0,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-337.128 -432.793)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13362",
    "data-name": "Path 13362",
    d: "M348.984,379.722v7.065a.268.268,0,0,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-337.128 -363.994)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13363",
    "data-name": "Path 13363",
    d: "M439.33,354.071h10.5a1.674,1.674,0,0,0,1.674-1.674V308.19a1.674,1.674,0,0,0-1.674-1.674h-10.5a1.674,1.674,0,0,0-1.674,1.674V352.4a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-415.012 -299.93)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13364",
    "data-name": "Path 13364",
    d: "M474.39,589.646a3.246,3.246,0,1,0-3.246,3.246,3.247,3.247,0,0,0,3.246-3.246",
    transform: "translate(-441.573 -545.761)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13365",
    "data-name": "Path 13365",
    d: "M468.661,590.909a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-439.091 -543.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13366",
    "data-name": "Path 13366",
    d: "M461.846,351.134h6.875a.618.618,0,0,0,.618-.618V325.021a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-435.716 -315.64)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13367",
    "data-name": "Path 13367",
    d: "M469.534,333.426H474.6a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-442.579 -322.624)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13368",
    "data-name": "Path 13368",
    d: "M503.083,470.831v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-472.478 -444.018)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13369",
    "data-name": "Path 13369",
    d: "M503.083,408.527v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-472.478 -389.294)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13370",
    "data-name": "Path 13370",
    d: "M477.818,470.831v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-450.287 -444.018)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13371",
    "data-name": "Path 13371",
    d: "M477.818,408.527v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-450.287 -389.294)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13372",
    "data-name": "Path 13372",
    d: "M490.965,458.051v7.065a.268.268,0,1,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-461.835 -432.793)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13373",
    "data-name": "Path 13373",
    d: "M490.965,379.722v7.065a.268.268,0,1,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-461.835 -363.994)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13374",
    "data-name": "Path 13374",
    d: "M584.022,354.071h10.5A1.674,1.674,0,0,0,596.2,352.4V308.19a1.674,1.674,0,0,0-1.674-1.674h-10.5a1.674,1.674,0,0,0-1.674,1.674V352.4a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-542.1 -299.93)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13375",
    "data-name": "Path 13375",
    d: "M619.083,589.646a3.246,3.246,0,1,0-3.246,3.246,3.246,3.246,0,0,0,3.246-3.246",
    transform: "translate(-568.662 -545.761)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13376",
    "data-name": "Path 13376",
    d: "M613.353,590.909a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-566.179 -543.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13377",
    "data-name": "Path 13377",
    d: "M606.54,351.134h6.875a.618.618,0,0,0,.618-.618V325.021a.618.618,0,0,0-.618-.618H606.54a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-562.806 -315.64)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13378",
    "data-name": "Path 13378",
    d: "M614.227,333.426h5.061a.493.493,0,0,0,.492-.492v-.087a.493.493,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-569.668 -322.624)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13379",
    "data-name": "Path 13379",
    d: "M647.775,470.831v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-599.567 -444.018)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13380",
    "data-name": "Path 13380",
    d: "M647.775,408.527v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-599.567 -389.294)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13381",
    "data-name": "Path 13381",
    d: "M622.511,470.831v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-577.376 -444.018)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13382",
    "data-name": "Path 13382",
    d: "M622.511,408.527v5.51a.268.268,0,1,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-577.376 -389.294)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13383",
    "data-name": "Path 13383",
    d: "M635.657,458.051v7.065a.268.268,0,1,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-588.923 -432.793)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13384",
    "data-name": "Path 13384",
    d: "M635.657,379.722v7.065a.268.268,0,0,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-588.923 -363.994)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13385",
    "data-name": "Path 13385",
    d: "M733.03,354.071h10.5a1.673,1.673,0,0,0,1.673-1.674V308.19a1.673,1.673,0,0,0-1.673-1.674h-10.5a1.674,1.674,0,0,0-1.674,1.674V352.4a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-672.979 -299.93)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13386",
    "data-name": "Path 13386",
    d: "M755.547,351.134h6.875a.619.619,0,0,0,.618-.618V325.021a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-693.684 -315.64)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13387",
    "data-name": "Path 13387",
    d: "M763.235,333.426H768.3a.493.493,0,0,0,.493-.492v-.087a.493.493,0,0,0-.493-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-700.547 -322.624)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13388",
    "data-name": "Path 13388",
    d: "M876.832,354.071h10.5a1.674,1.674,0,0,0,1.674-1.674V308.19a1.674,1.674,0,0,0-1.674-1.674h-10.5a1.674,1.674,0,0,0-1.674,1.674V352.4a1.673,1.673,0,0,0,1.674,1.674",
    transform: "translate(-799.285 -299.93)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13389",
    "data-name": "Path 13389",
    d: "M899.348,351.134h6.875a.618.618,0,0,0,.618-.618V325.021a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-819.989 -315.64)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13390",
    "data-name": "Path 13390",
    d: "M907.036,333.426H912.1a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-826.852 -322.624)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13391",
    "data-name": "Path 13391",
    d: "M297.351,796.179h10.5a1.674,1.674,0,0,0,1.674-1.674V750.3a1.674,1.674,0,0,0-1.674-1.673h-10.5a1.674,1.674,0,0,0-1.674,1.673v44.208a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-290.306 -688.249)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13392",
    "data-name": "Path 13392",
    d: "M332.409,1031.752a3.246,3.246,0,1,0-3.246,3.246,3.246,3.246,0,0,0,3.246-3.246",
    transform: "translate(-316.866 -934.079)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13393",
    "data-name": "Path 13393",
    d: "M326.68,1033.017a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-314.384 -931.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13394",
    "data-name": "Path 13394",
    d: "M319.867,793.24h6.875a.618.618,0,0,0,.618-.618V767.127a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-311.011 -703.958)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13395",
    "data-name": "Path 13395",
    d: "M327.553,775.532h5.061a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.493.493,0,0,0-.492.492v.087a.493.493,0,0,0,.492.492",
    transform: "translate(-317.872 -710.942)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13396",
    "data-name": "Path 13396",
    d: "M361.1,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-347.771 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13397",
    "data-name": "Path 13397",
    d: "M361.1,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-347.771 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13398",
    "data-name": "Path 13398",
    d: "M335.839,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-325.582 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13399",
    "data-name": "Path 13399",
    d: "M335.839,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-325.582 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13400",
    "data-name": "Path 13400",
    d: "M348.984,900.158v7.064a.268.268,0,1,0,.536,0v-7.064a.268.268,0,1,0-.536,0",
    transform: "translate(-337.128 -821.111)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13401",
    "data-name": "Path 13401",
    d: "M348.984,821.829v7.065a.268.268,0,0,0,.536,0v-7.065a.268.268,0,0,0-.536,0",
    transform: "translate(-337.128 -752.312)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13402",
    "data-name": "Path 13402",
    d: "M439.33,796.179h10.5a1.674,1.674,0,0,0,1.674-1.674V750.3a1.674,1.674,0,0,0-1.674-1.673h-10.5a1.674,1.674,0,0,0-1.674,1.673v44.208a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-415.012 -688.249)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13403",
    "data-name": "Path 13403",
    d: "M474.39,1031.752a3.246,3.246,0,1,0-3.246,3.246,3.247,3.247,0,0,0,3.246-3.246",
    transform: "translate(-441.573 -934.079)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13404",
    "data-name": "Path 13404",
    d: "M468.661,1033.017a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-439.091 -931.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13405",
    "data-name": "Path 13405",
    d: "M461.846,793.24h6.875a.618.618,0,0,0,.618-.618V767.127a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-435.716 -703.958)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13406",
    "data-name": "Path 13406",
    d: "M469.534,775.532H474.6a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-442.579 -710.942)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13407",
    "data-name": "Path 13407",
    d: "M503.083,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-472.478 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13408",
    "data-name": "Path 13408",
    d: "M503.083,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-472.478 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13409",
    "data-name": "Path 13409",
    d: "M477.818,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-450.287 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13410",
    "data-name": "Path 13410",
    d: "M477.818,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-450.287 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13411",
    "data-name": "Path 13411",
    d: "M490.965,900.158v7.064a.268.268,0,1,0,.536,0v-7.064a.268.268,0,1,0-.536,0",
    transform: "translate(-461.835 -821.111)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13412",
    "data-name": "Path 13412",
    d: "M490.965,821.829v7.065a.268.268,0,1,0,.536,0v-7.065a.268.268,0,1,0-.536,0",
    transform: "translate(-461.835 -752.312)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13413",
    "data-name": "Path 13413",
    d: "M584.022,796.179h10.5a1.674,1.674,0,0,0,1.674-1.674V750.3a1.674,1.674,0,0,0-1.674-1.673h-10.5a1.674,1.674,0,0,0-1.674,1.673v44.208a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-542.1 -688.249)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13414",
    "data-name": "Path 13414",
    d: "M733.03,796.179h10.5a1.674,1.674,0,0,0,1.673-1.674V750.3a1.674,1.674,0,0,0-1.673-1.673h-10.5a1.674,1.674,0,0,0-1.674,1.673v44.208a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-672.979 -688.249)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13415",
    "data-name": "Path 13415",
    d: "M876.832,796.179h10.5a1.674,1.674,0,0,0,1.674-1.674V750.3a1.674,1.674,0,0,0-1.674-1.673h-10.5a1.674,1.674,0,0,0-1.674,1.673v44.208a1.674,1.674,0,0,0,1.674,1.674",
    transform: "translate(-799.285 -688.249)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13416",
    "data-name": "Path 13416",
    d: "M253.2,388.165h0a1.665,1.665,0,0,1-1.665-1.665V254.042a1.665,1.665,0,1,1,3.33,0V386.5a1.665,1.665,0,0,1-1.665,1.665",
    transform: "translate(-251.534 -252.377)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14334",
    "data-name": "Rectangle 14334",
    width: 96.217,
    height: 1.337,
    transform: "translate(0 54.147)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14335",
    "data-name": "Rectangle 14335",
    width: 102.191,
    height: 1.337,
    transform: "translate(0 107.909)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13517",
    "data-name": "Path 13517",
    d: "M474.39,1031.752a3.246,3.246,0,1,0-3.246,3.246,3.247,3.247,0,0,0,3.246-3.246",
    transform: "translate(-441.573 -934.079)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13518",
    "data-name": "Path 13518",
    d: "M468.661,1033.017a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-421.391 -931.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13519",
    "data-name": "Path 13519",
    d: "M474.39,1031.752a3.246,3.246,0,1,0-3.246,3.246,3.247,3.247,0,0,0,3.246-3.246",
    transform: "translate(-423.873 -934.079)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13520",
    "data-name": "Path 13520",
    d: "M468.661,1033.017a3.59,3.59,0,1,1,3.59-3.59,3.594,3.594,0,0,1-3.59,3.59m0-6.493a2.9,2.9,0,1,0,2.9,2.9,2.906,2.906,0,0,0-2.9-2.9",
    transform: "translate(-403.358 -931.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13521",
    "data-name": "Path 13521",
    d: "M474.39,1031.752a3.246,3.246,0,1,0-3.246,3.246,3.247,3.247,0,0,0,3.246-3.246",
    transform: "translate(-405.841 -934.079)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13522",
    "data-name": "Path 13522",
    d: "M461.846,793.24h6.875a.618.618,0,0,0,.618-.618V767.127a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-418.244 -703.958)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13523",
    "data-name": "Path 13523",
    d: "M469.534,775.532H474.6a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-425.107 -710.942)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13524",
    "data-name": "Path 13524",
    d: "M503.083,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-455.007 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13525",
    "data-name": "Path 13525",
    d: "M503.083,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-455.007 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13526",
    "data-name": "Path 13526",
    d: "M477.818,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-432.815 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13527",
    "data-name": "Path 13527",
    d: "M477.818,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-432.815 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13528",
    "data-name": "Path 13528",
    d: "M490.965,900.158v7.064a.268.268,0,1,0,.536,0v-7.064a.268.268,0,1,0-.536,0",
    transform: "translate(-444.363 -821.111)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13529",
    "data-name": "Path 13529",
    d: "M490.965,821.829v7.065a.268.268,0,1,0,.536,0v-7.065a.268.268,0,1,0-.536,0",
    transform: "translate(-444.363 -752.312)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13530",
    "data-name": "Path 13530",
    d: "M461.846,793.24h6.875a.618.618,0,0,0,.618-.618V767.127a.618.618,0,0,0-.618-.618h-6.875a.618.618,0,0,0-.618.618v25.494a.618.618,0,0,0,.618.618",
    transform: "translate(-399.983 -703.958)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13531",
    "data-name": "Path 13531",
    d: "M469.534,775.532H474.6a.492.492,0,0,0,.492-.492v-.087a.492.492,0,0,0-.492-.492h-5.061a.492.492,0,0,0-.492.492v.087a.492.492,0,0,0,.492.492",
    transform: "translate(-406.846 -710.942)",
    fill: "#58dfc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13532",
    "data-name": "Path 13532",
    d: "M503.083,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-436.746 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13533",
    "data-name": "Path 13533",
    d: "M503.083,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-436.746 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13534",
    "data-name": "Path 13534",
    d: "M477.818,912.94v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,1,0-.536,0",
    transform: "translate(-414.554 -832.338)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13535",
    "data-name": "Path 13535",
    d: "M477.818,850.635v5.51a.268.268,0,0,0,.536,0v-5.51a.268.268,0,0,0-.536,0",
    transform: "translate(-414.554 -777.613)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13536",
    "data-name": "Path 13536",
    d: "M490.965,900.158v7.064a.268.268,0,1,0,.536,0v-7.064a.268.268,0,1,0-.536,0",
    transform: "translate(-426.102 -821.111)",
    fill: "#505aba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13537",
    "data-name": "Path 13537",
    d: "M490.965,821.829v7.065a.268.268,0,1,0,.536,0v-7.065a.268.268,0,1,0-.536,0",
    transform: "translate(-426.102 -752.312)",
    fill: "#505aba"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13417",
    "data-name": "Path 13417",
    d: "M1687.035,623.86s-9.148,7.941-7.565,9.552,9.555-9.583,9.555-9.583,11.978,2.7,15.12,5.722c0,0-12.6,4.852-10.666,6.023s15.273-3.268,15.273-3.268,10.2,5.4,7.451,11.8-7.139,7.209-8.717,6.5-9.945-7.519-10.6-6.247,3.668,7.55,7.634,9.083c0,0-10.383,5.891-14.646,1.8s-3.43-8.076-6.11-10.557-5.375-3.364-4.557-1.465,6.058,5.208,6.812,8.994,1.663,6.472-3.314,3.959-12.228-9.148-11.156-13.659l.134-.564a2.219,2.219,0,0,0-.134.564c-1.155-.165-4.08,1.094-6.237,2.129-.344.194-.844.444-1.546.765-.3.155-.552.284-.724.374-4.5,2.581-8.865,9.736-8.865,9.736l-1.109-.479a19.4,19.4,0,0,1,11.01-10.761,22.341,22.341,0,0,0,8.543-6.276s-4.582-11.133,4.217-14.347c0,0,6.117-1.408,10.194.212",
    transform: "translate(-1451.951 -547.274)",
    fill: "#58dfc3",
    opacity: 0.496
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14337",
    "data-name": "Rectangle 14337",
    width: 7.868,
    height: 25.381,
    transform: "translate(268.219 116.653)",
    fill: "#35488b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14338",
    "data-name": "Rectangle 14338",
    width: 18.974,
    height: 25.381,
    transform: "translate(249.245 116.653)",
    fill: "#252078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13418",
    "data-name": "Path 13418",
    d: "M2228.749,975.387a1.313,1.313,0,1,0-1.313,1.313,1.313,1.313,0,0,0,1.313-1.313",
    transform: "translate(-1955.283 -855.565)",
    fill: "#dde7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13419",
    "data-name": "Path 13419",
    d: "M2231.141,978.164a.929.929,0,1,0-.928.928.928.928,0,0,0,.928-.928",
    transform: "translate(-1958.06 -858.342)",
    fill: "#6c7aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14339",
    "data-name": "Rectangle 14339",
    width: 3.701,
    height: 6.685,
    transform: "translate(270.273 122.986)",
    fill: "#8fadef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14340",
    "data-name": "Rectangle 14340",
    width: 7.868,
    height: 25.381,
    transform: "translate(253.541 116.653)",
    fill: "#35488b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14341",
    "data-name": "Rectangle 14341",
    width: 18.974,
    height: 25.381,
    transform: "translate(234.568 116.653)",
    fill: "#252078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13420",
    "data-name": "Path 13420",
    d: "M2108.109,975.387a1.313,1.313,0,1,0-1.313,1.313,1.313,1.313,0,0,0,1.313-1.313",
    transform: "translate(-1849.321 -855.565)",
    fill: "#dde7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13421",
    "data-name": "Path 13421",
    d: "M2110.5,978.164a.929.929,0,1,0-.929.928.929.929,0,0,0,.929-.928",
    transform: "translate(-1852.098 -858.342)",
    fill: "#6c7aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14342",
    "data-name": "Rectangle 14342",
    width: 3.701,
    height: 6.685,
    transform: "translate(255.596 122.986)",
    fill: "#8fadef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14343",
    "data-name": "Rectangle 14343",
    width: 7.868,
    height: 25.381,
    transform: "translate(240.121 116.653)",
    fill: "#35488b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14344",
    "data-name": "Rectangle 14344",
    width: 18.974,
    height: 25.381,
    transform: "translate(221.147 116.653)",
    fill: "#252078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13422",
    "data-name": "Path 13422",
    d: "M1997.8,975.387a1.313,1.313,0,1,0-1.313,1.313,1.313,1.313,0,0,0,1.313-1.313",
    transform: "translate(-1752.434 -855.565)",
    fill: "#dde7fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13423",
    "data-name": "Path 13423",
    d: "M2000.193,978.164a.929.929,0,1,0-.929.928.929.929,0,0,0,.929-.928",
    transform: "translate(-1755.21 -858.342)",
    fill: "#6c7aff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14345",
    "data-name": "Rectangle 14345",
    width: 3.701,
    height: 6.685,
    transform: "translate(242.175 122.986)",
    fill: "#8fadef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13516",
    "data-name": "Path 13516",
    d: "M0,0H44.452V32.843H0Z",
    transform: "translate(219.965 133.181)",
    fill: "#b9e5da"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14347",
    "data-name": "Rectangle 14347",
    width: 35.245,
    height: 32.843,
    transform: "translate(243.787 133.181)",
    fill: "#89d3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13424",
    "data-name": "Path 13424",
    d: "M2120.186,1122.937h9.13a1.031,1.031,0,0,0,1.028-1.028v-.133a1.031,1.031,0,0,0-1.028-1.028h-9.13a1.031,1.031,0,0,0-1.027,1.028v.133a1.031,1.031,0,0,0,1.027,1.028",
    transform: "translate(-1861.333 -984.394)",
    fill: "#252078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13425",
    "data-name": "Path 13425",
    d: "M1213.854,736.976l-6.012,71.477s-.63,4.333,2.593,4.34c5.3.013,26.375,0,26.375,0s-3.988-.9-3.94-2.931c.057-2.392,7.026-73.563,7.026-73.563Z",
    transform: "translate(-1060.847 -646.719)",
    fill: "#798ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13426",
    "data-name": "Path 13426",
    d: "M1251.3,801.907c-1.042,0-21.447.038-26.607-.029-2.249-.028-2.643-2-2.662-3.276a6.392,6.392,0,0,1,.068-1.064l.156-1.858.4-4.735.352-4.183.452-5.376.381-4.537,4.271-50.789,26.043-.676s-2.935,29.785-5.011,51.465c-.232,2.416-.452,4.732-.656,6.894q-.1,1.035-.191,2.022c-.193,2.051-.368,3.935-.522,5.6-.081.877-.155,1.691-.223,2.437-.265,2.924-.42,4.791-.422,5.146a3.008,3.008,0,0,0,.051.579c.427,2.278,3.73,2.381,4.121,2.381",
    transform: "translate(-1073.354 -637.131)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13427",
    "data-name": "Path 13427",
    d: "M737.763,421.911l14.643,58.817,2,8.055,6.82,27.395h126.7L862.8,421.911Z",
    transform: "translate(-648.004 -370.58)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13428",
    "data-name": "Path 13428",
    d: "M723.111,421.91l-2.029.676,22.8,95.637,2.7-2.046Z",
    transform: "translate(-633.352 -370.579)",
    fill: "#798ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13429",
    "data-name": "Path 13429",
    d: "M908.477,1198.774H1034.4l3.477-2.046h-126.7Z",
    transform: "translate(-797.947 -1051.13)",
    fill: "#849def"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14348",
    "data-name": "Rectangle 14348",
    width: 27.264,
    height: 1.296,
    transform: "translate(154.749 164.776)",
    fill: "#aec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13430",
    "data-name": "Path 13430",
    d: "M1252.941,1213.541l-.141.99-25.64,5.18.352-4.183.167-1.987Z",
    transform: "translate(-1077.858 -1065.896)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8506",
    "data-name": "Group 8506",
    transform: "translate(148.679 156.67)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8505",
    "data-name": "Group 8505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8504",
    "data-name": "Group 8504",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13431",
    "data-name": "Path 13431",
    d: "M1251.307,1295.834c-1.042,0-21.447.037-26.607-.029-2.249-.028-2.643-2-2.662-3.276l25.519-4.8c-.265,2.924-.42,4.791-.422,5.146a3,3,0,0,0,.051.579c.427,2.278,3.73,2.381,4.121,2.381",
    transform: "translate(-1222.038 -1287.728)",
    fill: "#8c9df4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13432",
    "data-name": "Path 13432",
    d: "M737.762,421.91H862.795l20.287,75.761H756.622Z",
    transform: "translate(-648.003 -370.579)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13433",
    "data-name": "Path 13433",
    d: "M914.57,523.69H797.5l-4.184-16.665-1.619-6.448-.66-2.63-4.3-17.127-.222-.892-2.273-9.053-1.017-4.051-.867-3.455-.708-2.818-1.326-5.281H895.708l1.456,5.281.776,2.818.953,3.455,1.116,4.051,7.357,26.686h0l.623,2.261.29,1.049,5.079,18.423Z",
    transform: "translate(-685.388 -399.881)",
    fill: "#7284fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13436",
    "data-name": "Path 13436",
    d: "M659.783,1040.637l-.653-1.616a4.585,4.585,0,0,0-4.252-2.868H642.837v40.262H692.65v-32.621H664.462a5.046,5.046,0,0,1-4.679-3.156",
    transform: "translate(-564.627 -910.091)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13455",
    "data-name": "Path 13455",
    d: "M865.475,588.892l-1.08-1.594a6.3,6.3,0,0,0-4.967-2.829H847.552L849.613,592l8.178,29.9a3.083,3.083,0,0,0,2.974,2.27H903.5a3.083,3.083,0,0,0,2.974-3.9L898.742,592h-27.8a6.937,6.937,0,0,1-5.466-3.113",
    transform: "translate(-744.435 -513.361)",
    fill: "#b9e5da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13456",
    "data-name": "Path 13456",
    d: "M1003.766,504.31a.66.66,0,0,0-.118.706.006.006,0,0,0,0,0,4.391,4.391,0,0,0,1.387,1.523c.084.068.158.129.223.186l.05.045.038.035c.61.562.38.691,1.476,1.832,1.249,1.3,2.109,1.324,2.354,1.206.207-.1-.214-.79-.679-1.566l-.068-.113c-.062-.1-.124-.208-.185-.311-.546-.933-.405-1.37-.275-2.758.106-1.128,1.757-6.3,1.757-6.3l-2.394-.413s-.722,4.119-1.517,4.753c-.425.338-.9.342-1.309.593l-.085.054a3.142,3.142,0,0,0-.655.526",
    transform: "translate(-881.494 -437.749)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13457",
    "data-name": "Path 13457",
    d: "M1003.766,543.292a.66.66,0,0,0-.118.706.006.006,0,0,0,0,0,5.086,5.086,0,0,0,1.39,1.518c.082.069.155.132.22.191l.05.045.038.035c.61.562.38.691,1.476,1.833,1.249,1.3,2.109,1.324,2.354,1.206.207-.1-.214-.79-.679-1.566a5.324,5.324,0,0,1-2.226-1.642c-.725-.925-1.217-2.1-1.71-2.829l-.141-.026a3.143,3.143,0,0,0-.655.526",
    transform: "translate(-881.494 -476.731)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13458",
    "data-name": "Path 13458",
    d: "M1149.875,497.6c.148.739,1.2.616,2.378.329s.9.055,2.572-.13,2.183-.809,2.234-1.058c.046-.221-.782-.3-1.67-.4l-.336-.04a7.252,7.252,0,0,1-2.647-1.3,10.634,10.634,0,0,1-2.149-2.554l-2.3.181s1.2,1.831,1.671,2.628a2.776,2.776,0,0,1,.225,1.566,2.947,2.947,0,0,0,.017.786",
    transform: "translate(-1008.296 -432.529)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13459",
    "data-name": "Path 13459",
    d: "M1165.813,526.077c1.177-.287.9.055,2.572-.13s2.183-.809,2.234-1.058c.046-.221-.782-.3-1.67-.4l-.008.017a4.722,4.722,0,0,1-2.4.745c-1.137.027-2.34-.3-3.125-.286a2.947,2.947,0,0,0,.017.786c.148.739,1.2.616,2.378.329",
    transform: "translate(-1021.856 -460.676)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13460",
    "data-name": "Path 13460",
    d: "M1034.439,387.5l-2.15,5.778-2.806,7.544a4.54,4.54,0,0,1-1.49-.137,6.459,6.459,0,0,1-1.44-.7s.781-8.1,2.235-12.752a8.281,8.281,0,0,1,1.251-2.7c2.252-2.66,4.4,2.97,4.4,2.97",
    transform: "translate(-901.658 -337.118)",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13461",
    "data-name": "Path 13461",
    d: "M923.468,330.274c-1.222-.395-4.412-.008-7.872.617a2.346,2.346,0,0,1-2.423-1.095l-8.707-.683s-2.875,6.37-1.3,10.431a1.528,1.528,0,0,0,1.521.982h0s5.261.009,6.944.01c4.33,0,9.165-2.973,9.79-3.1,1.024-.2,1.432,1.843,2.455,3.993s9.618,9.522,9.618,9.522a7.564,7.564,0,0,0,1.867-.191,1.839,1.839,0,0,0,.8-.506s-9.52-18.957-12.692-19.982",
    transform: "translate(-792.867 -289.072)",
    fill: "#acadad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13462",
    "data-name": "Path 13462",
    d: "M878.924,120.843a3.089,3.089,0,0,0-1.663-.433,4.618,4.618,0,0,1-.8-.049c-3.323-.488-5.326,4.338-5.444,5.8-.216,2.677-1.633,3.085-3.627,4.762-4,3.361-2.828,7.268-.643,8.721,1.311.871,3.624,0,3.624,0,.033.023,6.324-3.514,9.425-5.22,4.648-.659,1-12.465-.869-13.577",
    transform: "translate(-759.534 -105.687)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13463",
    "data-name": "Path 13463",
    d: "M936.47,189.018a4.1,4.1,0,0,1-2.555.078,4.555,4.555,0,0,1-1.686-2.022c.44-.02.924-.405,1.3-2.932l.188.067,3.153,1.136s-.229,1.012-.377,1.975c-.125.809-.192,1.584-.02,1.7",
    transform: "translate(-818.809 -161.739)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13464",
    "data-name": "Path 13464",
    d: "M947.587,185.832s-.126.546-.31,1.566a3.56,3.56,0,0,1-2.843-2.7Z",
    transform: "translate(-829.53 -162.226)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13465",
    "data-name": "Path 13465",
    d: "M945.777,147.5s-4.314-.58-3.911-3.262.118-4.562,2.889-4.3,3.152,1.361,3.235,2.288-1.08,5.36-2.213,5.278",
    transform: "translate(-827.251 -122.885)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13466",
    "data-name": "Path 13466",
    d: "M938.9,139.038s-2.763,2.379-4.641,2.57a3.6,3.6,0,0,1-2.59-.412,7.337,7.337,0,0,0,1.775-2.4,1.321,1.321,0,0,1,1.089-.778c1.342-.115,3.884-.167,4.367,1.022",
    transform: "translate(-818.319 -121.175)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13467",
    "data-name": "Path 13467",
    d: "M976.915,141.347a6.8,6.8,0,0,1,1.214,1.556,5.219,5.219,0,0,1,.141,2.776s1.441-2.8.626-4.159a1.15,1.15,0,0,0-1.981-.174",
    transform: "translate(-858.059 -123.697)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13468",
    "data-name": "Path 13468",
    d: "M913.352,215.805c-.133,8.733-.038,6.908-.994,7.737a3.672,3.672,0,0,1-1.729.374c-2.678.177-7.385-.266-7.564-.761-.617-1.713-.181-2.244-.7-4.866-.054-.279-.12-.581-.2-.909-.429-1.8-.847-2.413.678-5.306A22.579,22.579,0,0,1,905.8,207.4c3.647,2.166,3.941.347,3.941.347s3.677,3.794,3.611,8.054",
    transform: "translate(-792.061 -182.169)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13469",
    "data-name": "Path 13469",
    d: "M1032.289,417.941l-2.806,7.545a4.539,4.539,0,0,1-1.49-.137,6.452,6.452,0,0,1-1.44-.7s.781-8.1,2.235-12.752Z",
    transform: "translate(-901.658 -361.783)",
    fill: "#acadad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13470",
    "data-name": "Path 13470",
    d: "M967.252,210.264s3.753.638,4.193,2.254,1.887,11.424,1.887,11.424-1.059,1.033-1.94.151-2.771-9.177-2.771-9.177Z",
    transform: "translate(-849.572 -184.683)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13471",
    "data-name": "Path 13471",
    d: "M914.924,276.254c-2.678.177-7.385-.266-7.564-.761-.617-1.713-.181-2.244-.7-4.866l1.293-3.637s-.215,4.05.979,5.116,4.89,2.058,5.47,2.948a3.257,3.257,0,0,1,.517,1.2",
    transform: "translate(-796.356 -234.507)",
    fill: "#edcea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13472",
    "data-name": "Path 13472",
    d: "M949.337,326.179s2.642-.587,3.068-.353a6.2,6.2,0,0,1,1.6,1.386c.131.3-.949-.226-1.3-.32a3.122,3.122,0,0,0-1.122.246,3.73,3.73,0,0,1-2.011.2Z",
    transform: "translate(-833.837 -286.137)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13473",
    "data-name": "Path 13473",
    d: "M873.017,207.4s-3.547.217-4.776,1.93c-1.729,2.411-5.162,12.685-3.2,14.056,2.213,1.544,10.073.407,10.073.407a3.193,3.193,0,0,0-.1-1.814c-.364-.591-6.277-1.549-6.55-1.822s3.414-5.321,3.414-6.14,1.138-6.617,1.138-6.617",
    transform: "translate(-759.28 -182.171)",
    fill: "#f9ddbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13474",
    "data-name": "Path 13474",
    d: "M975.606,332.27a5.1,5.1,0,0,0,.735.8.543.543,0,0,0,.3.064l-.373-.672Z",
    transform: "translate(-856.91 -291.845)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13475",
    "data-name": "Path 13475",
    d: "M974.558,326.225l1.609.782a.286.286,0,0,1-.267.1,3.824,3.824,0,0,1-.7-.192Z",
    transform: "translate(-855.989 -286.536)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13476",
    "data-name": "Path 13476",
    d: "M966.143,341.323l-16.811-.006v.371l16.662.006Z",
    transform: "translate(-833.832 -299.791)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13477",
    "data-name": "Path 13477",
    d: "M981.644,275.634l12.731,0,3.833-9.522-12.711,0Z",
    transform: "translate(-862.213 -233.736)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13478",
    "data-name": "Path 13478",
    d: "M1050.953,300.89a.441.441,0,0,0-.432-.606.869.869,0,0,0-.78.606.441.441,0,0,0,.432.606.869.869,0,0,0,.78-.606",
    transform: "translate(-922.003 -263.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8509",
    "data-name": "Group 8509",
    transform: "translate(166.14 65.646)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8508",
    "data-name": "Group 8508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8507",
    "data-name": "Group 8507",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13479",
    "data-name": "Path 13479",
    d: "M1391.164,547.308l-3.521-4.5-.166-.212-.2-.037-16.252-2.99-5.469,29.726,21.069,3.876,4.678-25.429.038-.208Z",
    transform: "translate(-1365.557 -539.571)",
    fill: "#8c9df4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13480",
    "data-name": "Path 13480",
    d: "M1333.438,498.68l.008.211,1,25.836-21.407.831-1.171-30.2,16.512-.64.2-.008.209.171,4.421,3.618Z",
    transform: "translate(-1152.263 -434.52)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13481",
    "data-name": "Path 13481",
    d: "M1114.608,588.167l-35.724,1.991a.131.131,0,0,0-.124.138l2.607,46.78a.131.131,0,0,0,.138.124l35.673-1.988a.131.131,0,0,0,.123-.138l-2.61-46.831a.08.08,0,0,0-.084-.075",
    transform: "translate(-947.514 -516.609)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13482",
    "data-name": "Path 13482",
    d: "M1123.149,642.109l-30.26,1.9a1.647,1.647,0,0,1-1.747-1.54l-2.58-41.117a1.647,1.647,0,0,1,1.54-1.747l30.26-1.9a1.647,1.647,0,0,1,1.747,1.54l2.58,41.116a1.647,1.647,0,0,1-1.54,1.747",
    transform: "translate(-956.12 -524.984)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13483",
    "data-name": "Path 13483",
    d: "M1136.934,649.785l-19.035,1.194a.017.017,0,0,1-.019-.016l-.03-.476a.018.018,0,0,1,.016-.019l19.035-1.194a.018.018,0,0,1,.019.017l.03.476a.018.018,0,0,1-.016.019",
    transform: "translate(-981.847 -570.281)",
    fill: "#d54678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13484",
    "data-name": "Path 13484",
    d: "M1139.042,683.377l-19.036,1.194a.018.018,0,0,1-.019-.016l-.03-.476a.017.017,0,0,1,.016-.019l19.035-1.195a.018.018,0,0,1,.019.017l.03.476a.018.018,0,0,1-.017.019",
    transform: "translate(-983.699 -599.786)",
    fill: "#d54678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13485",
    "data-name": "Path 13485",
    d: "M1145.26,662.83l-26.308,1.651a.018.018,0,0,1-.019-.016l-.03-.476a.018.018,0,0,1,.017-.019l26.308-1.651a.018.018,0,0,1,.019.016l.03.476a.017.017,0,0,1-.016.019",
    transform: "translate(-982.773 -581.739)",
    fill: "#d54678"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13486",
    "data-name": "Path 13486",
    d: "M1145.176,790.166l-12.951.813a.015.015,0,0,1-.016-.014l-.03-.482a.015.015,0,0,1,.014-.015l12.951-.813a.015.015,0,0,1,.015.014l.03.482a.014.014,0,0,1-.013.015",
    transform: "translate(-994.433 -693.583)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13487",
    "data-name": "Path 13487",
    d: "M1149.072,770.818l-17.9,1.123a.015.015,0,0,1-.016-.014l-.03-.482a.015.015,0,0,1,.014-.016l17.9-1.123a.015.015,0,0,1,.015.013l.03.482a.014.014,0,0,1-.014.015",
    transform: "translate(-993.507 -676.589)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13488",
    "data-name": "Path 13488",
    d: "M1151.708,805.769l-19.036,1.194a.017.017,0,0,1-.019-.016l-.03-.476a.018.018,0,0,1,.017-.019l19.035-1.194a.018.018,0,0,1,.019.017l.03.476a.018.018,0,0,1-.016.019",
    transform: "translate(-994.824 -707.287)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13489",
    "data-name": "Path 13489",
    d: "M1154.891,821.466l-21.166,1.328a.016.016,0,0,1-.017-.015l-.03-.479a.016.016,0,0,1,.015-.017l21.166-1.328a.016.016,0,0,1,.017.015l.03.479a.016.016,0,0,1-.015.017",
    transform: "translate(-995.75 -721.075)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13490",
    "data-name": "Path 13490",
    d: "M1150.152,854.79l-13.623.855a.016.016,0,0,1-.016-.014l-.03-.481a.015.015,0,0,1,.014-.016l13.623-.855a.015.015,0,0,1,.016.014l.03.481a.015.015,0,0,1-.014.016",
    transform: "translate(-998.214 -750.344)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13491",
    "data-name": "Path 13491",
    d: "M1152.26,888.382l-13.623.855a.015.015,0,0,1-.016-.014l-.03-.481a.015.015,0,0,1,.014-.016l13.623-.855a.015.015,0,0,1,.016.014l.03.481a.015.015,0,0,1-.014.016",
    transform: "translate(-1000.066 -779.849)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13492",
    "data-name": "Path 13492",
    d: "M1156.413,868.9l-18.829,1.181a.015.015,0,0,1-.016-.014l-.03-.481a.015.015,0,0,1,.014-.016l18.829-1.181a.015.015,0,0,1,.016.014l.03.481a.015.015,0,0,1-.014.016",
    transform: "translate(-999.14 -762.738)",
    fill: "#bdd1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13493",
    "data-name": "Path 13493",
    d: "M1159.5,571.392l-16.66.929a1.925,1.925,0,0,0-1.886,1.958l.14,2.518a.445.445,0,0,0,.483.4l19.718-1.1a.445.445,0,0,0,.436-.453l-.14-2.518a1.925,1.925,0,0,0-2.092-1.736",
    transform: "translate(-1002.141 -501.871)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13494",
    "data-name": "Path 13494",
    d: "M1522.866,720.371s-.346-.779-.571-1.148-1.182-1.449-1.345-1.2-.815,1.891-.469,2.352-.023,1.263,1.7,1.749Z",
    transform: "translate(-1335.406 -630.631)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13495",
    "data-name": "Path 13495",
    d: "M1553.357,697.194s-8.823,7.364-12.263,6.683c-2.69-.533-6.943-1.882-6.943-1.882a2.714,2.714,0,0,0-.8,2.347s5.418,5.1,9.278,5.131c6.034.052,8.879-2.99,8.879-2.99Z",
    transform: "translate(-1346.744 -612.371)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13496",
    "data-name": "Path 13496",
    d: "M1752.132,1326.069s-.256,4.131-1.056,4.191c-.106.008-4.054.008-4.054.008l-5.039-.029a1.635,1.635,0,0,1,1.506-1.471c1.473-.257,3.939-1.292,4.831-3.239.938-2.048,3.812.541,3.812.541",
    transform: "translate(-1530.046 -1163.567)",
    fill: "#113c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13497",
    "data-name": "Path 13497",
    d: "M1704.36,969.793a10.5,10.5,0,0,1-2.728.513,10.015,10.015,0,0,1-2.547-.363,69.76,69.76,0,0,0-1.876-8.935c-.832-3.221-2.021-7.363-3.711-12.509-4.674-14.223-6.1-22.544-6.225-23.332-.007-.042-.01-.062-.01-.062l.015-.007,14.371-6.31s-1.776,19.6.49,27.127a31.765,31.765,0,0,1,.823,3.6c1.431,8.173,1.4,20.274,1.4,20.274",
    transform: "translate(-1481.984 -807.004)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13498",
    "data-name": "Path 13498",
    d: "M1697.28,961.006c-.832-3.221-2.02-7.363-3.711-12.509-4.675-14.223-6.1-22.544-6.226-23.332,0-.023,0-.046.005-.069l14.371-6.31s-1.776,19.6.49,27.127c.317,1.052-4.93,15.093-4.93,15.093",
    transform: "translate(-1482.054 -807.003)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13499",
    "data-name": "Path 13499",
    d: "M1659.874,1326.069s-.256,4.131-1.056,4.191c-.106.008-4.054.008-4.054.008l-5.039-.029a1.635,1.635,0,0,1,1.506-1.471c1.473-.257,3.938-1.292,4.831-3.239.938-2.048,3.812.541,3.812.541",
    transform: "translate(-1449.012 -1163.567)",
    fill: "#15447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13500",
    "data-name": "Path 13500",
    d: "M1666.145,922.583a204.6,204.6,0,0,0,2.011,28.3c2.2,15.6,1.453,22.218,1.453,22.218a14.973,14.973,0,0,0,2.119.539,9.618,9.618,0,0,0,3.144-.364s3.146-15.6,2.244-23.409,4.308-26.788,4.308-26.788Z",
    transform: "translate(-1463.431 -810.338)",
    fill: "#2a4e96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13501",
    "data-name": "Path 13501",
    d: "M1706.914,632.917l-2.805,1.84-2.555-.722a6.109,6.109,0,0,1-.6-3.064,19.05,19.05,0,0,1,.1-2.04l3.785-1.67,1.412-.622c0,.022-.11,1.159-.125,1.326a9.66,9.66,0,0,0,.786,4.953",
    transform: "translate(-1494.01 -550.399)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13502",
    "data-name": "Path 13502",
    d: "M1665.224,703.816c3.492,3.371,16.706,2.8,17.521-.91s-.888-31.619-6.853-33.372c-1.238-.364-7.855,1.775-7.855,1.775a41.952,41.952,0,0,0-1.719,6.174c-.132.673-.518,7.8-.807,14.476-.135,3.12-.249,6.14-.307,8.352a24.082,24.082,0,0,0,.02,3.506",
    transform: "translate(-1462.574 -588.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13503",
    "data-name": "Path 13503",
    d: "M1705.845,632.505c-.768,1.3-3.462,2.434-4.889,2.955a19.013,19.013,0,0,1,.1-2.04l3.785-1.67c.837-.011,1.346.176,1,.756",
    transform: "translate(-1494.01 -554.888)",
    fill: "#fca56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13504",
    "data-name": "Path 13504",
    d: "M1684.545,571.13s6.1,1.9,7.224-1.914,2.672-6.14-1.174-7.516-5.035-.144-5.721,1.038-1.886,7.8-.329,8.392",
    transform: "translate(-1478.927 -492.829)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13505",
    "data-name": "Path 13505",
    d: "M1690.582,547.329s.389,4.441,1.307,4.248,1.929-.605,1.795.733.893,3.633,2.217,3.628c2.84-.012,5.926-7.3,5.148-8.681-2.243-3.987-13.709-4.792-10.467.072",
    transform: "translate(-1484.395 -477.787)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13506",
    "data-name": "Path 13506",
    d: "M1690.386,657.106c.079-.033,4.54-2.034,5.061-1.862s1.172,1.766,1.172,1.766l-7.855,1.776a3.9,3.9,0,0,1,1.622-1.68",
    transform: "translate(-1483.302 -575.516)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13507",
    "data-name": "Path 13507",
    d: "M1469.993,830.99,1495,854.534c.49.461,1.108.608,1.374.327l.844-.9c.265-.282.081-.89-.409-1.351L1471.8,829.069c-.49-.462-1.108-.609-1.373-.327l-.844.9c-.265.282-.081.89.409,1.351",
    transform: "translate(-1290.681 -727.789)",
    fill: "#1f4d84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13508",
    "data-name": "Path 13508",
    d: "M1589.165,942.98l10.973,10.332c.49.462,1.108.609,1.374.327l.844-.9c.265-.282.081-.89-.409-1.351l-10.974-10.332Z",
    transform: "translate(-1395.821 -826.566)",
    fill: "#739af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13509",
    "data-name": "Path 13509",
    d: "M1239.728,573.251a19.6,19.6,0,0,0-27.7-.843c-.1.1-.207.2-.308.3a19.6,19.6,0,1,0,28.011.547m-1.9,26.58a18.054,18.054,0,1,1,.777-25.519,18.033,18.033,0,0,1-.777,25.519",
    transform: "translate(-1059.145 -498.09)",
    fill: "#1f4d84"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8512",
    "data-name": "Group 8512",
    transform: "translate(148.256 70.541)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8511",
    "data-name": "Group 8511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8510",
    "data-name": "Group 8510",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13510",
    "data-name": "Path 13510",
    d: "M1223.479,610.224a18.054,18.054,0,1,0,.778-25.518,17.977,17.977,0,0,0-.778,25.518",
    transform: "translate(-1218.575 -579.802)",
    fill: "#b3cff9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13511",
    "data-name": "Path 13511",
    d: "M1665.483,757.324c13.779-9.819,12.633-22.92,12.633-22.92-5.036,2.84-10.033,9.121-12.326,14.569-.135,3.12-.249,6.14-.307,8.352",
    transform: "translate(-1462.853 -645.054)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13512",
    "data-name": "Path 13512",
    d: "M1525.131,878.194a3.763,3.763,0,0,1-1.76-1.087s-.414.028.068.912c.04.074.13.264.2.4a.086.086,0,0,1-.072.123,9.174,9.174,0,0,0-2.2.046c-.149.031-.193.388-.187.54a1.379,1.379,0,0,0,.29.941,4.812,4.812,0,0,0,1.741.912,5.267,5.267,0,0,0,2.694-.338l.882-.409-.274-1.639-.222.046c-.352.074-.788-.356-1.155-.446",
    transform: "translate(-1336.101 -770.395)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13513",
    "data-name": "Path 13513",
    d: "M1582.955,684.43s12.38,2.357-3.642,20.286c-2.563,2.867-16.408,6.6-16.408,6.6s-1.4-1.195-.7-2.162c0,0,9.533-6.922,11.63-8.023.944-.495,3.662-11.049,5.2-13.59a6.934,6.934,0,0,1,3.916-3.111",
    transform: "translate(-1371.968 -601.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13514",
    "data-name": "Path 13514",
    d: "M1525.925,717.612a6.3,6.3,0,0,1-.484-1.182,6.534,6.534,0,0,0-.8-1.809c-.084-.084-.361.025-.394.385a2.091,2.091,0,0,0,.2.783,8.836,8.836,0,0,1,.262,1.556c.192.624,1.216.266,1.216.266",
    transform: "translate(-1338.8 -627.654)",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13515",
    "data-name": "Path 13515",
    d: "M0,0H300.524V166.9H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionOfPricesDesign);
export default __webpack_public_path__ + "static/media/CollectionOfPricesDesign.b9ea3d0c642699a3b4db2c7640824465.svg";
export { ForwardRef as ReactComponent };